import { Icon } from '@/Icon';
import { theme } from './GlobalStyles';

import styled from '@emotion/styled';
import { information } from 'information';

const PhoneIconSvg = styled.svg`
    width: 24px;
    height: 24px;
    flex-shrink: 0;
`;

interface Props {
    color: 'white' | 'red' | 'black';
    className?: string;
}

const LocationLinkStyled = styled.div<Props>`
    min-width: 32px;
    height: 32px;
    border-radius: 5px;
    margin-bottom: 1em;
    transition: all 0.2s ease-in-out;
    :hover {
        a {
            color: ${theme.colors.red1};
        }
    }

    svg {
        fill: ${({ color }) =>
            (color === 'red' && theme.colors.red1) || (color === 'white' && theme.colors.gray1)};
    }
    a {
        line-height: 152.5%;
        transition: all 0.2s ease-in-out;
        text-decoration: underline;
        display: flex;
        font-size: 16px;
        color: ${({ color }) =>
            (color === 'red' && theme.colors.red1) ||
            (color === 'white' && theme.colors.white) ||
            (color === 'black' && theme.colors.gray5)};
        align-items: center;
        .marker-svg {
            width: 17px;
        }
        svg {
            transition: all 0.2s ease-in-out;
            transform: scale(1);
        }
        span {
            margin-left: 17px;
        }
        &:hover {
            svg {
                transform: scale(1.1);
            }
        }
    }
`;

interface ComponentProps extends Props {
    type: 'email' | 'phone' | 'map';
    className?: string;
}

export const LocationLink: React.FC<ComponentProps> = ({ type, className, color }) => {
    return (
        <LocationLinkStyled color={color} className={className}>
            {type === 'phone' && (
                <a href={`tel:${information.phone}`} target="_blank" rel="noreferrer">
                    <PhoneIconSvg
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                        dangerouslySetInnerHTML={{ __html: '<path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" fill="#4B5049"/>' }}
                    />

                    <span>{information.phone}</span>
                </a>
            )}
            {type === 'email' && (
                <a href={`mailto:${information.email}`} target="_blank" rel="noreferrer">
                    <Icon name="mail" className="email" />
                    <span>{information.email}</span>
                </a>
            )}
            {type === 'map' && (
                <a href={`${information.locationUrl}`} target="_blank" rel="noreferrer">
                    <Icon name="marker-black" className="marker" />
                    <span>{information.location}</span>
                </a>
            )}
        </LocationLinkStyled>
    );
};
